import React, { Component } from 'react';
import { Form,FormControl,  Nav, Navbar, Jumbotron, Button, ButtonToolbar } from 'react-bootstrap';

class TestButton extends Component {

  constructor(props) {
    super(props);
  }

  clickButton() {
    return this.props.testClick();
  }

  render() {
    return (
      <div className="App">
        <h2>Buttons</h2>

        <div>
          <ButtonToolbar>
              <Button>Default</Button>
              <Button bsStyle="primary">Primary</Button>
              <Button bsStyle="success">Success</Button>
              <Button bsStyle="info">Info</Button>
              <Button bsStyle="warning">Warning</Button>
              <Button bsStyle="danger">Danger</Button>
              <Button bsStyle="link">Link</Button>
              <Button bsStyle="link" onClick={() => {this.clickButton()}}>Link</Button>
          </ButtonToolbar>
        </div>
      </div>
    )
  }
}

export default TestButton;
